// Copyright (c) Proto Labs, Inc. All Rights Reserved.
/* eslint-disable no-console */
import { TokenManagerLogLevel } from './TokenManagerLogLevel';
export class TokenManagerLogger {
    constructor(level) {
        this.level = TokenManagerLogLevel.Warn;
        this.setLevel(level);
    }
    getLevel() {
        return this.level;
    }
    setLevel(value) {
        if (TokenManagerLogLevel.None <= value && value <= TokenManagerLogLevel.Debug) {
            this.level = value;
        }
        else {
            this.level = TokenManagerLogLevel.Warn;
        }
    }
    debug(message) {
        if (this.level >= TokenManagerLogLevel.Debug) {
            console.debug(message);
        }
    }
    info(message) {
        if (this.level >= TokenManagerLogLevel.Info) {
            console.info(message);
        }
    }
    warn(message) {
        if (this.level >= TokenManagerLogLevel.Warn) {
            console.warn(message);
        }
    }
    error(message) {
        if (this.level >= TokenManagerLogLevel.Error) {
            console.error(message);
        }
    }
}
//# sourceMappingURL=TokenManagerLogger.js.map